<template>
    <div>
        <div class="about-us">
            <re-nav-bar
                v-on:app="scroll_to('re-the-applciation')"
            ></re-nav-bar>
            <div class="au-content">
                <div class="au-content-item au-pg-img-container">
                    <img :src="require('../../assets/Desktop/About_Us/00-img.svg')" alt="page 0">
                </div>
                <div class="au-content-item">
                    <p class="au-subtitle">ABOUT US</p>
                </div>
                <div class="au-content-item">
                    <h1 class="au-title">About Royal Experience</h1>
                </div>
                <div class="au-content-item">
                    <p class="au-text">We at Royal Experience are dedicated to be the global leader in providing businesses and individuals the most convenient, efficient, and exclusive luxury concierge / hospitality services through digital technology.</p>
                </div>
            </div>
        </div>
        <div class="au-pattern-background">
            <div ref='re-the-offering'><re-benefits></re-benefits></div>
            <div ref='re-company-breakdown'><re-business-customer></re-business-customer></div>
            <re-vendor></re-vendor>
            <div ref="re-the-applciation"><re-about-application></re-about-application></div>
        </div>
        <re-sign-up></re-sign-up>
        <re-footer
            v-on:app="scroll_to('re-the-applciation')"
            v-on:offer="scroll_to('re-the-offering')"
            v-on:company="scroll_to('re-company-breakdown')"
        ></re-footer>
    </div>
</template>

<script>
    import Benefits from './Benefits.vue'
    import Sign_Up from './Sign_Up.vue'
    import Vendor from './Vendor.vue'
    import Footer from '../Footer.vue'
    import Nav_Bar from '../Nav_Bar.vue'
    import Business_Customer from './Business_Customer.vue'
    import About_Application from './About_Application.vue'

    export default {
        data () {
            return {
            }
        },
        components: {
            're-benefits': Benefits,
            're-sign-up': Sign_Up,
            're-vendor': Vendor,
            're-footer': Footer,
            're-nav-bar': Nav_Bar,
            're-business-customer': Business_Customer,
            're-about-application': About_Application
        },
        methods: {
            scroll_to(refName) {
    	        let element = this.$refs[refName];
                let top = element.offsetTop;
                window.scrollTo(0, top);
            },
        }
    }
</script>

<style scoped>
    @media (max-width: 880px) {
        .au-content {
            margin-top: 60px !important;
        }

        .au-title {
            margin: 25px auto !important;
        }

        .au-text {
            width: 350px !important;
            margin: 15px auto !important;
        }
    }

    .about-us {
        height: 770px;
        background-image: url(../../assets/Desktop/About_Us/about_background.jpg);
    }

    .au-content {
        margin-top: 160px;
        display: flex;
        flex-direction: column;
    }

    .au-content-item {
        text-align: center;
    }

    .au-pg-img-container {
        margin: 35px 0;
    }

    .au-subtitle {
        color: #DAAE3E;
        font-family: Trirong;
        font-size: 12px;
        font-weight: bold;
        letter-spacing: 2.31px;
        line-height: 20px;
    }

    .au-title {
        color: #FFFFFF;
        font-family: Trirong;
        font-size: 40px;
        font-weight: 800;
        line-height: 49px;
        margin: 10px auto;
    }

    .au-text {
        width: 646px;
        margin: auto;
        color: #FFFFFF;
        font-family: Trirong;
        font-size: 15px;
        letter-spacing: 1px;
        line-height: 28px;
    }
</style>



// WEBPACK FOOTER //
// src/components/about/About.vue